<template>
  <b-modal id="modalPopover" v-model="value" hide-footer :title="$t('errors.error')" ok-only>
    <h5 class="text-center my-4">
      {{ errorText }}
    </h5>
    <button class="btn btn-primary" @click="closeModal()">{{ $t('buttons.hide') }}</button>
  </b-modal>
</template>

<script>
export default {
  name: "ErrorModal",
  props: {
    errorText: {
      required: false,
      type: String,
      default: () => this.$t('errors.undefined_error')
    },
    value:{
      required: true,
    }

  },
  methods:{
    closeModal(){
      this.$emit('closeModal')
    }
  }

}
</script>

<style scoped>

</style>